import { useState } from "react";

export default function PricingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: "Can I switch plans at any time?",
      answer: "Yes! You can upgrade or downgrade your plan at any time. If you upgrade, you'll be charged the prorated difference immediately. If you downgrade, the change will take effect at the end of your current billing cycle."
    },
    {
      question: "What happens to my data if I downgrade or cancel?",
      answer: "Your flight data is always yours. If you downgrade to Free, you'll keep access to all your historical flights, but new flights will be limited to 5 per month. If you cancel, your data remains accessible in read-only mode for 90 days, after which it's archived."
    },
    {
      question: "Do you offer refunds?",
      answer: "We offer a 14-day money-back guarantee on all paid plans. If you're not satisfied within the first 14 days, contact us for a full refund — no questions asked."
    },
    {
      question: "Is there a discount for flight schools or bulk licenses?",
      answer: "Yes! We offer custom pricing for flight schools, universities, and organizations purchasing 10+ Instructor licenses. Contact our sales team for a tailored quote and onboarding support."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards (Visa, Mastercard, Amex, Discover) and PayPal. Annual plans can also be paid via bank transfer or purchase order for organizations."
    },
    {
      question: "Can I try Pro or Instructor before committing?",
      answer: "Absolutely! Pro includes a 14-day free trial — no credit card required. Instructor plans come with a 7-day trial and a personalized onboarding call to help you get started."
    }
  ];

  return (
    <section className="relative py-20">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Frequently asked questions</h2>
          <p className="text-lg text-gray-400">Everything you need to know about pricing and plans</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden transition-all hover:border-[#00FFD1]/30"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
              >
                <span className="text-lg font-semibold pr-8">{faq.question}</span>
                <i
                  className={`text-[#00FFD1] text-xl transition-transform flex-shrink-0 ${
                    openIndex === index ? "ri-subtract-line" : "ri-add-line"
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6 text-gray-300 leading-relaxed border-t border-white/10 pt-6">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}